<template>
  <div>
    <div class="forward-templateall">
      <div class="articlebox">
        <div class="articleright">
          <div class="article-r-top">
            <div class="cleardynamic" @click="showModal">
              <span class="cuIcon-more">
                <van-icon name="ellipsis" />
              </span>
            </div>

            <div class="article-title">
              <div class="articletx">
                <img :src="messageList.avatar_url?messageList.avatar_url:avatar_url" @click.stop="gotootherdynamic(messageList.api_uid)" />
              </div>
              <div>
                <div class="article-author" @click.stop="gotootherdynamic(messageList.api_uid)">{{messageList.name}}
                  <div class="dynamictop-dj">
                    <img src="../../assets/images/circle_icon_denji.png"></img>
                    <span>1</span>
                  </div>
                </div>
                <div class="article-time">{{messageList.ctime}}</div>
              </div>
            </div>
          </div>

          <div v-if="!isPidInfo">
            <div class="article-content">
              <pre class="article-content-text">{{messageList.content}}</pre>
            </div>

            <div class="article-imagebox">
              <div class="imgArea" v-if="messageList.msg_type==1">
                <!-- wx:if="{{!item.imgArea}}" -->
                <div v-if="messageList.thumb.length==1" class="block01">
                  <div v-if="messageList.is_long==1">
                    <div v-for="(item,index) in messageList.thumb" :key="index">
                      <img :src="item" class="longpic" @click.stop="showImg" :data-imgurl="messageList.extra" :data-imgidx="index" />
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="(item,index) in messageList.thumb" :key="index">
                      <img :src="item" class="widthpic" @click.stop="showImg" :data-imgurl="messageList.extra" :data-imgidx="index" />
                    </div>
                  </div>
                </div>

                <div v-else class="block02">
                  <div v-for="(item,index) in messageList.extra" :key="index">
                    <!-- <img :src="item" @click="onChange(index)" /> -->
                    <van-image fit="cover" :src="item" @click="onChange(index)" />
                  </div>

                  <van-image-preview v-model="show" :images="messageList.extra" @change="onChange" :startPosition="index">
                    <template v-slot:index>第{{index+1}}张</template>
                  </van-image-preview>
                </div>
              </div>
              <div v-else class="videoshowbox">
                <div class="widevideo" v-if="messageList.is_long==0">
                  <div v-for="(item,index) in messageList.extra" :key="index">
                    <img v-if="isTalk" class="widevideo" :src="messageList.thumb[0]" />
                    <video v-else class="widevideo" style="width= 100%; height=100%; object-fit: contain; background:#333" :src="item" controls webkit-playsinline="true" playsinline="true" :poster="messageList.thumb[0]"></video>
                  </div>
                </div>
                <div class="longvideo" v-else>
                  <div v-for="(item,index) in messageList.extra" :key="index">
                    <img v-if="isTalk" class="longvideo" :src="messageList.thumb[0]" />
                    <video v-else class="longvideo" style="width= 100%; height=100%; object-fit: fill;background:#333" :src="item" controls webkit-playsinline="true" playsinline="true" :poster="messageList.thumb[0]"></video>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--转发的内容-->
          <div v-else class="forward-content">
            <!-- <div v-if="isPidInfo" class="forward-content"> -->
            <div class="forward-content-nrbox">
              <div>
                <span class="content-text02 cuIcon-pic" v-if="messageList.extra.length != 0" @click.stop="showImg" :data-imgurl="messageList.extra">查看图片</span>
                <pre style="padding-right:0.2702702702702703rem ;">{{messageList.content}}</pre>
              </div>

              <!--      <div class="article-content-btn" @click="openbtn">
                            <p>展开</p>
                            <p>收起</p>
              </div>-->
            </div>

            <div class="forward-othercontent" @click="gotocircledetails(messageList.pid_info.id,0)">
              <div class="f-o-topbox">
                <div class="f-o-toptx">
                  <img :src="messageList.pid_info.avatar_url" />
                </div>
                <div class="f-o-topname">{{messageList.pid_info.name}}</div>
              </div>
              <pre class="f-o-commentbox">{{messageList.pid_info.content}}</pre>
              <!-- <div class="morediv">
                            <p>更多</p>
              </div>-->

              <div class="f-o-imgbox">
                <div class="imgAreabox" v-if="messageList.pid_info.msg_type==1">
                  <!-- wx:if="{{!item.imgArea}}" -->
                  <div v-if="messageList.pid_info.thumb.length==1" class="block01">
                    <div v-if="messageList.pid_info.is_long==1">
                      <div v-for="(item,index) in messageList.pid_info.thumb" :key="index">
                        <img :src="item" class="longpic" @click.stop="showImg" :data-imgurl="messageList.pid_info.extra" :data-imgidx="index" />
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="(item,index) in messageList.pid_info.thumb" :key="index">
                        <img :src="item" class="widthpic" @click.stop="showImg" :data-imgurl="messageList.pid_info.extra" :data-imgidx="index" />
                      </div>
                    </div>
                  </div>

                  <div v-else class="block02">
                    <div v-for="(item,index) in messageList.pid_info.extra" :key="index">
                      <!-- <img :src="item" @click="onChange(index)" /> -->
                      <van-image fit="cover" :src="item" @click="onChange(index)" />
                    </div>

                    <van-image-preview v-model="show" :images="messageList.pid_info.extra" @change="onChange" :startPosition="index">
                      <template v-slot:index>第{{index+1}}张</template>
                    </van-image-preview>
                  </div>
                </div>
                <div v-else class="videoshowbox">
                  <div class="widevideo" v-if="messageList.pid_info.is_long==0">
                    <div v-for="(item,index) in messageList.pid_info.extra" :key="index">
                      <video class="widevideo" controls style="width= 100%; height=100%; object-fit: contain; background:#333" :src="item" webkit-playsinline="true" playsinline="true"></video>
                    </div>
                  </div>
                  <div class="longvideo" v-else>
                    <div v-for="(item,index) in messageList.pid_info.extra" :key="index">
                      <video class="longvideo" style="width= 100%; height=100%; object-fit: fill;background:#333" controls :src="item" webkit-playsinline="true" playsinline="true"></video>
                    </div>
                  </div>
                </div>
              </div>
              <div class="forward_info">{{messageList.pid_info.forward_num}}转发 · {{messageList.pid_info.comment_num}}评论 · {{messageList.pid_info.nices_num}}鼓掌</div>
            </div>
          </div>

          <div class="article-circlefollow" v-if="messageList.like_name!=''" @click.stop="gotocirclecontent" :data-cid="messageList.like_id">
            <div>
              <span class="cuIcon-playfill righticon">
                <van-icon name="play" />
              </span>
              <img src="../../assets/images/dynamic_icon_qz-w.png" />
              <span>{{messageList.like_name}}</span>
            </div>
          </div>

          <div class="article-echo">
            <!-- <div class="xianxian"></div> -->
            <div class="article-echo-cell article-echo-forward" @click="gotoforward" :data-id="messageList.id">
              <img src="../../assets/images/dynamic_icon_forwarding.png" />
              <span v-if="messageList.forward_num == 0">转发</span>
              <span v-else>{{messageList.forward_num}}</span>
            </div>
            <div class="article-echo-cell article-echo-comment" @click="upCommentbigchild" data-id="1" :data-toname="toName">
              <img src="../../assets/images/dynamic_icon_comment.png" />
              <span v-if="messageList.comment_num==0">评论</span>
              <span v-else>{{messageList.comment_num}}</span>
            </div>
            <div class="article-echo-cell article-echo-applause" @click="applausebtn" :data-id="messageList.id">
              <div v-if="messageList.is_nice == 1">
                <img src="../../assets/images/dynamic_btn_applause_selected.png" />
                <span class="red">{{messageList.nices_num}}</span>
              </div>
              <div v-else>
                <img src="../../assets/images/dynamic_btn_applause_normal.png" />
                <span v-if="messageList.nices_num == 0">鼓掌</span>
                <span v-else class="textnum">{{messageList.nices_num}}</span>
              </div>
            </div>
            <div class="article-echo-cell article-echo-applause">
              <img src="../../assets/images/dynamic_icon_share_a.png" />
              <button @click.stop="showDynamicPopup()" v-clipboard:copy="config.link">分享</button>
            </div>
          </div>
        </div>
      </div>

      <!-- <van-action-sheet
        v-model="isActionSheet"
        :actions="actions"
        cancel-text="取消"
        @select="onSelect"
        @cancel="onCancel"
      />-->

      <van-popup v-model="isActionSheet" position="bottom" :style="{ height: '19%' }">
        <dl class="cleardl">
          <dt v-if="messageList.is_own==1" @click="onSelect">删除</dt>
          <dt v-else @click="jubao(messageList.id)">举报</dt>
          <dd @click="hidePopup">取消</dd>
        </dl>
      </van-popup>

      <!--动态详情--分享到-->
      <van-popup v-model="showDPopup" position="bottom" :style="{ height: '50%' }">
        <div class="sharedownbox">
          <vue-native-share :shareMenu="shareMenu" :config="config" :fzljLink="fzljLink" />
        </div>
        <van-button class="sharetopbox" @click="hidePopup" type="default" block>取消分享</van-button>
      </van-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getnicemsg, cleardynamic } from "../../api/api";
import vueNativeShare from "../plugins/vue-native-share";
import { mapState } from "vuex";
import Vue from "vue";

import { ImagePreview, ActionSheet, Toast, Dialog } from "vant";

Vue.use(ImagePreview);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(Dialog);
export default {
  name: "ddetailstop",
  components: {
    vueNativeShare
  },
  props: [
    "messageList",
    "toName",
    "listindex",
    "isPidInfo",
    "dqdtid",
    "isTalk"
  ],
  data () {
    return {
      TabCur: 0,
      scrollLeft: 0,
      circleNo: 0,
      windowHeight: 590,
      imgArr: [],
      applausenum: 0,
      //applauseicon:`${app.globalData.baseImgUrl}/xianpipa/images/dynamic_btn_applause_normal.png`,
      //applauseicon02:`${app.globalData.baseImgUrl}/xianpipa/images/dynamic_btn_applause_selected.png`,
      currentSize: 0,
      words: [],
      dynamiccontent: {},
      dynamiclist: [], //动态列表
      page: 0, //从第一页
      pageCount: null, //总页数
      nices_num: 0,
      showactive: 0,
      alldynamiccnum: 0, //所有动态的条数
      scrolltop: "",
      otherrenid: "", //查看其他人的动态
      circleid: "",
      msgtype: 0, //默认分类
      nodynamic: false,
      isdytemple: true, //表示是动态的模板
      ondynamicid: "", //当前动态的ID
      downshow: false,
      showtopshowbox: false,
      //isIphoneX: app.globalData.isIphoneX,  //显示头部
      is_own: "",
      show: false,
      index: 0,
      startPosition: 0,
      images: [],
      isActionSheet: false,
      actions: [{ name: "删除" }],
      avatar_url: require("../../assets/images/moren.jpg"),
      config: {
        title: "鲜枇杷名片-圈子",
        desc: "免费为企业/个人制作电子名片，扫描二维码生成你的专属电子名片",
        img: "https://api.xianpipa.com/xianpipa/images/logo.png",
        img_title: "一款名片应用",
        link: "",
        success: () => {
          console.log("success");
        },
        cancel: () => {
          console.log("cancel");
        }
      },
      showDPopup: false,
      shareMenu: [0, 1, 2, 3],
      fzljLink: ''
    };
  },
  created () {
    var url = window.location.href;
    this.config.link = url;
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  mounted () {
    //this.show = true;
  },
  methods: {
    showDynamicPopup (i) {
      this.fzljLink = this.messageList.shareUrl
      if (/micromessenger/i.test(navigator.userAgent)) {
        //微信复制链接
        Toast.success({
          duration: 2000,
          message: "链接已复制，快去分享吧！"
        });
      } else {
        this.showDPopup = true;
      }
    },
    showImg (e) {
      let outidx = e.currentTarget.dataset.outidx;
      let imgidx = e.currentTarget.dataset.imgidx;
      let imgshowurl = e.currentTarget.dataset.imgurl;
      ImagePreview([imgshowurl]);
    },
    //跳转到圈子
    gotocirclecontent (e) {
      let circleid = e.currentTarget.dataset.cid;
      this.$router.push({
        path: "/circlecontent",
        query: {
          id: circleid
        }
      });
    },
    //删除动态
    onSelect () {
      let that = this;

      Dialog.confirm({
        title: "提示",
        message: "确定删除动态"
      })
        .then(() => {
          cleardy();
          that.isActionSheet = false;
        })
        .catch(() => {
          that.isActionSheet = false;
        });

      let ondynamicid = this.messageList.id;

      function cleardy () {
        axios.defaults.headers.common["PLATFORM"] = "H5";
        const instance = axios.create({
          withCredentials: false
        });

        let baseURL = this.baseAPI;

        instance
          .delete(baseURL + "/v1/messages/" + ondynamicid)
          .then(res => {
            Toast.success({
              message: "删除成功",
              duration: 1000,
              onClose () {
                that.$router.go(-1);
              }
            });
          })
          .catch(function (error) {
            Toast.fail({
              message: "删除失败",
              duration: 2000
            });
          });
      }
    },
    //举报
    jubao (e) {
      let that = this;
      let ondynamicid = e;
      Dialog.confirm({
        title: "提示",
        message: "是否举报该信息"
      })
        .then(() => {
          jubaody();
        })
        .catch(() => {
          // on cancel
          that.isActionSheet = false;
        });

      function jubaody () {
        that.$router.push({
          name: "report",
          query: {
            id: ondynamicid
          }
        });
      }
    },
    //跳转到动态详情
    gotocircledetails (id, index) {
      this.$router.push({
        path: "/dynamicdetails",
        query: {
          index: 0,
          id: id
        }
      });
    },
    //关闭上拉框
    hidePopup () {
      this.isActionSheet = false;
      this.showDPopup = false;
    },
    //显示上拉框
    showModal () {
      this.isActionSheet = true;
    },
    onChange (index) {
      this.index = index;
      this.show = true;
      this.startPosition = index + 1;
    },
    upCommentbigchild (e) {
      this.$emit("upCommentbig", e);
    },
    initMyMssagechild (dqdtid) {
      this.$emit("initMyMssage", dqdtid);
    },
    //鼓掌功能
    guzhang: function (item_id, listindex) {
      var that = this;
      var show; //传递到数据库点赞的状态
      var cookie_mid = this.$store.getters.getGuzhang || []; //获取全部点赞的mid

      if (that.messageList.id == item_id) {
        //遍历找到对应的id

        var num = that.messageList.nices_num; //当前赞数
        var isnice = that.messageList.is_nice;
        var isshow; //点赞的状态
        getnicemsg(item_id).then(res => {
          if (res.code == 200) {
            if (cookie_mid.includes(item_id) || isnice == 1) {
              //说明已经点过赞,取消赞
              for (var j = 0; j < cookie_mid.length; j++) {
                if (cookie_mid[j] == item_id) {
                  cookie_mid.splice(j, 1); //删除取消赞的mid
                }
              }
              --num;
              if (num < 0) {
                num == 0;
              }

              isshow = 0; //点赞的状态

              that.messageList.nices_num = num;
              that.messageList.is_nice = isshow;
              that.$store.dispatch("changeGuzhangFun", cookie_mid);
            } else {
              isshow = 1; //点赞的状态
              ++num;

              that.messageList.nices_num = num;
              that.messageList.is_nice = isshow;
              cookie_mid.unshift(item_id); //新增赞的mid
              that.$store.dispatch("changeGuzhangFun", cookie_mid);
            }

            /*           
          更新上一页的点赞数据
          let api_uid = that.data.api_uid;

          getmydynamic(api_uid).then(res => {

          
            if (res.code == 200) {
              var pages = getCurrentPages();
            
                var prePage = pages[pages.length - 2];
                prePage.setData({
                  dynamiclist: res.data.list,
                  showactive:0
                })
            
              //wx.navigateBack()  
            }

          }); */

            let dqdtid = this.dqdtid;
            that.initMyMssagechild(dqdtid);
          }
        });
      }
    },
    applausebtn (e) {
      var item_id = e.currentTarget.dataset.id; //此处找到列表的id
      var listindex = this.listindex;
      this.guzhang(item_id, listindex);
    },
    //转发
    gotoforward (e) {
      let msg_id = e.currentTarget.dataset.id;
      let is_own = this.messageList.is_own;
      this.$router.push({
        path: "/forward",
        query: {
          isdynamic: false,
          is_own: is_own,
          msg_id: msg_id
        }
      });
    },
    //跳转到动态页面
    gotootherdynamic (e) {
      let otherrenid = e;

      this.$router.push({
        name: "dynamic",
        query: {
          otherrenid: otherrenid
        }
      });
    }
  }
};
</script>

<style scoped>
.forward-templateall .articlebox {
  padding-top: 50px;
  flex-flow: row nowrap;
  border-bottom: 0.40540540540540543rem solid #f8f8f8;
  background: #fff;
  border-top: 0.5px solid #f8f8f8;
}
.forward-templateall .articlebox .articleleft {
  width: 3.135135135135135rem;
}

.forward-templateall .articlebox .articleright .articletx {
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
  margin-right: 0.5405405405405406rem;
  margin-left: 0.3rem;
}
.forward-templateall .articlebox .articleright .articletx img {
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
  border: 1px solid #f2f2f2;
}
.forward-templateall .articlebox .articleright {
  margin: 0 0.3rem;
}
.forward-templateall .articlebox .articleright .article-r-top {
  padding-top: 0.8108108108108109rem;
}
.forward-templateall .articlebox .articleright .article-r-top .article-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-author {
  font-size: 0.7567567567567568rem;
  color: #333;
  font-weight: bold;
}

.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-author
  .dynamictop-dj {
  display: inline-block;
  width: 17px;
  height: 18px;
  position: relative;
  top: 3px;
}

.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-author
  .dynamictop-dj
  img {
  width: 19px;
  height: 19px;
  position: absolute;
  top: 0;
  left: 0;
}

.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-author
  .dynamictop-dj
  span {
  display: inline-block;
  width: 17px;
  text-align: center;
  font-size: 12px;
  z-index: 3;
  position: absolute;
  top: 0;
  left: 0;
  line-height: 16px;
  color: #fff;
  font-weight: normal;
}

.forward-templateall .articlebox .articleright .article-r-top .followbtn {
  float: right;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .followbtn
  button {
  width: 3.7567567567567566rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #ffbd0a;
  line-height: 1.3513513513513513rem;
  color: #ffbd0a;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .followbtn
  .active {
  width: 3.7567567567567566rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #999;
  line-height: 1.3513513513513513rem;
  color: #999;
}
.forward-templateall .articlebox .articleright .article-r-top .cleardynamic {
  float: right;
  padding-top: 0.13513513513513514rem;
  padding-right: 0.4864864864864865rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .cleardynamic
  span {
  color: #999;
  font-size: 1.5rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-time {
  padding-top: 0.2702702702702703rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}

.forward-templateall .articlebox .articleright .article-content {
  position: relative;
  padding: 0.4rem 0.27rem 0 0.27rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-text {
  color: #333;
  font-size: 0.75rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
  line-height: 1.0810810810810811rem;
  overflow: hidden;
  max-height: 6.486486486486487rem;
}
.forward-templateall .articlebox .articleright .article-content .bigheight {
  color: #333;
  font-size: 0.7567567567567568rem;
  white-space: wrap;
  text-overflow: ellipsis;
  line-height: 1.0810810810810811rem;
  overflow: auto;
  max-height: auto;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-btn {
  padding-top: 0.40540540540540543rem;
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-btn
  p {
  font-size: 0.75rem;
}
.forward-templateall .articlebox .articleright .article-imagebox {
  margin-top: 0.8108108108108109rem;
  background: #fff;
  margin-bottom: 0.40540540540540543rem;
  padding: 0 0.2702702702702703rem;
}

.forward-templateall .articlebox .articleright .article-imagebox .imgArea {
}

.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02 {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02
  .van-image {
  width: 6rem;
  height: 6rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02
  img {
  width: 6rem;
  height: 6rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01 {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01
  img.widthpic {
  width: 12.432432432432432rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01
  img.longpic {
  width: 12.432432432432432rem;
  max-height: 16.486486486486488rem;
  margin: 0 0.13513513513513514rem;
}

.forward-templateall .articlebox .articleright .article-imagebox .videoshowbox {
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .longvideo {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .widevideo {
  width: 100%;
  height: 10.675675675675675rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .longvideobox {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .longvideobox
  .longvideo {
  width: 12.162162162162161rem;
}

.forward-templateall .articlebox .articleright .article-echo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 0.8108108108108109rem 0;
  margin: 0.6756756756756757rem 0.2702702702702703rem 0 0.2702702702702703rem;
  border-top: 1px solid #e5e5e5;
}
.forward-templateall .articlebox .articleright .article-echo div {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.forward-templateall .articlebox .articleright .article-echo div img {
  width: 1.027027027027027rem;
  height: 1.0810810810810811rem;
  margin-right: 0.40540540540540543rem;
}
.forward-templateall .articlebox .articleright .article-echo div span,
.forward-templateall .articlebox .articleright .article-echo div button {
  font-size: 0.7567567567567568rem;
  color: #333;
  border: 0;
  background: #fff;
}
.forward-templateall .articlebox .articleright .article-echo div span.red {
  color: red;
}
.forward-templateall .articlebox .articleright .article-videobox video {
  display: inline-block;
  max-width: 100%;
  height: auto;
  min-width: 70%;
}

.forward-templateall .articlebox .articleright .article-circlefollow {
  min-width: 6.756756756756757rem;
  height: 1.6216216216216217rem;
  background: #ffbd0a;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  margin-top: 0.6756756756756757rem;
  margin-left: 0.21621621621621623rem;
  display: inline-block;
}
.forward-templateall .articlebox .articleright .article-circlefollow img {
  width: 0.9rem;

  float: left;
  margin-top: 0.3783783783783784rem;
  margin-left: 0.5405405405405406rem;
}
.forward-templateall .articlebox .articleright .article-circlefollow span {
  color: #fff;
  float: left;
  margin-left: 0.40540540540540543rem;
  /*  padding-right: 0.2702702702702703rem; */
  padding-top: 0.394324rem;
  font-size: 0.72rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-circlefollow
  .righticon {
  float: right;
  font-size: 0.5405405405405406rem;
  padding-right: 0.2702702702702703rem;
  padding-top: 0.5rem;
}

.forward-templateall .articlebox .articleright .forward-content {
  clear: both;
  overflow: hidden;
  padding: 0.40540540540540543rem 0.2702702702702703rem 0 0.2702702702702703rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox {
  font-size: 0.7567567567567568rem;
  line-height: 1.2432432432432432rem;
  padding-bottom: 0.5405405405405406rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .article-content-btn {
  padding-top: 0.40540540540540543rem;
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .article-content-text {
  color: #333;
  font-size: 0.7567567567567568rem;
  line-height: 1.0810810810810811rem;
  overflow: hidden;
  max-height: 6.486486486486487rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .bigheight {
  color: #333;
  font-size: 0.7567567567567568rem;
  line-height: 1.0810810810810811rem;
  overflow: auto;
  max-height: auto;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  img.content-img {
  margin-left: 0.2702702702702703rem;
  width: 0.8648648648648649rem;
  margin-bottom: -0.08108108108108109rem;
  height: 0.7297297297297297rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .content-text02 {
  color: #6699ff;
  font-size: 0.7027027027027027rem;
  white-space: nowrap;
  padding-right: 0.40540540540540543rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .cuIcon-pic {
  font-size: 0.7297297297297297rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent {
  background: #f6f6f6;
  padding: 0.5rem;
  border-radius: 0.2702702702702703rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox {
  overflow: hidden;
  clear: both;
  padding-right: 0.5405405405405406rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-toptx {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  float: left;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-toptx
  img {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  border-radius: 50%;
  border: 1px solid #f2f2f2;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-topname {
  float: left;
  padding-top: 0.21621621621621623rem;
  padding-left: 0.5405405405405406rem;
  font-size: 0.7567567567567568rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-commentbox {
  max-height: 7.027027027027027rem;
  overflow: hidden;
  line-height: 1.0810810810810811rem;
  padding: 0.5405405405405406rem 0.2702702702702703rem 0 0.2702702702702703rem;
  font-size: 0.75rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .deltext {
  color: #999;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .moreview {
  padding-top: 0.40540540540540543rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .moreview
  text {
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-infobox {
  padding-top: 0.5405405405405406rem;
  color: #999;
  padding: 0 0.2702702702702703rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02 {
  margin-top: 0.5405405405405406rem;
  display: flex;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-items: flex-start;
  padding: 0.25rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02
  .van-image {
  width: 5.45945945945946rem;
  height: 5.45945945945946rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02
  img {
  width: 5.45945945945946rem;
  height: 5.45945945945946rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01 {
  margin-top: 0.5405405405405406rem;
  display: flex;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-items: flex-start;
  padding: 0.2702702702702703rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01
  img {
  width: 12.432432432432432rem;
  margin: 0 0.13513513513513514rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videoshowbox {
  padding-top: 0.5405405405405406rem;
  padding-left: 0.2702702702702703rem;
  padding-right: 0.2702702702702703rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videoshowbox
  .longvideo {
  width: 12.432432432432432rem;
  height: 16.486486486486488rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videoshowbox
  .widevideo {
  width: 100%;
  height: 10.675675675675675rem;
}

.forward_info {
  color: #999;
  font-size: 0.6486486486486487rem;
  margin: 0.2702702702702703rem 0;
}
.videoicon {
  width: 2.7027027027027026rem;
  height: 2.7027027027027026rem;
  position: absolute;
  top: 50%;
  right: 50%;
  margin-top: -1.3513513513513513rem;
  margin-right: -1.3513513513513513rem;
}
.cleardl {
}
.cleardl dt {
  text-align: center;
  border-bottom: 5px solid #f8f8f8;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  font-size: 0.7567567567567568rem;
}
.cleardl dd {
  text-align: center;
  padding-top: 0.9rem;
  font-size: 0.7567567567567568rem;
}
.sharetopbox {
  position: absolute;
  bottom: 0;
}
pre {
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/public/ddetailstop.vue